import { Record } from "immutable";
import type { EnhancedContentComponent } from "models/interfaces/enhanced-content-component";
import { RecordUtils } from "@rsm-hcd/javascript-core";

const defaultValues: EnhancedContentComponent =
    RecordUtils.defaultValuesFactory({
        annexId: undefined,
        articleId: undefined,
        chapterId: undefined,
        enhancedContentId: undefined,
        publicationId: undefined,
        sectionId: undefined,
    });

export default class EnhancedContentComponentRecord
    extends Record(defaultValues)
    implements EnhancedContentComponent
{
    // -----------------------------------------------------------------------------------------
    // #region Properties
    // -----------------------------------------------------------------------------------------

    // Do NOT set properties on immutable records due to babel and typescript transpilation issue
    // See https://github.com/facebook/create-react-app/issues/6506

    // #endregion Properties

    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: EnhancedContentComponent) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------

    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<EnhancedContentComponent>} values
     */
    public with(
        values: Partial<EnhancedContentComponent>
    ): EnhancedContentComponentRecord {
        return new EnhancedContentComponentRecord(
            Object.assign(this.toJS(), values)
        );
    }

    // #endregion Public Methods
}
